import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Forecast } from './components/Forecast';
import { ProductGrid } from './components/ProductGrid';
import { Bundle } from './components/Bundle';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { products } from './data/mockData';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans selection:bg-[#93e9be] selection:text-[#0a192f]">
      <Navbar />
      
      <main>
        <Hero />
        <Forecast />
        
        <ProductGrid 
          id="boards"
          title="Performance Shapes" 
          subtitle="Precision-milled and hand-finished for optimal speed and control in critical sections."
          products={products.boards} 
        />
        
        <ProductGrid 
          id="wetsuits"
          title="Thermal Defense" 
          subtitle="Premium neoprene construction keeping you warmer, looser, and in the water longer."
          products={products.wetsuits} 
        />
        
        <Bundle />
        
        <ProductGrid 
          id="accessories"
          title="Essential Hardware" 
          subtitle="The critical components that keep you connected and performing at your peak."
          products={products.accessories} 
        />
        
        <Reviews />
        <FAQ />
      </main>

      <Footer />
    </div>
  );
}

export default App;